// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q5Q5","rootMobile":"styles_rootMobile__2OZma"};